import { SellabilityRange } from '../../domain/types';

export const sellabilityRanges: Record<SellabilityRange, [number, number]> = {
  [SellabilityRange.UP_TO_50_MQ]: [0, 50],
  [SellabilityRange.BETWEEN_50_AND_85_MQ]: [51, 85],
  [SellabilityRange.BETWEEN_85_AND_115_MQ]: [86, 115],
  [SellabilityRange.BETWEEN_115_AND_145_MQ]: [116, 145],
  [SellabilityRange.OVER_145_MQ]: [146, Number.POSITIVE_INFINITY],
};
